import { ModalView360 } from './ModalView360';

export type { TypeModalView360Props } from './types';
export default ModalView360;
